module.exports = __webpack_public_path__ + "static/media/cq_modifica_documento.1c0aeddf.svg";